import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isFetching: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byEntityIdByModule: {}
}
const settingsModulesReducer = (
    state = initialState,
    { payload, type }: any
) => {
    switch (type) {
        case getActionType(ACTIONS.FETCH_MODULES).REQUEST: {
            return {
                ...state,
                _forceFetch: false,
                _isFetching: true
            }
        }

        case getActionType(ACTIONS.FETCH_MODULES).SUCCESS: {
            const { data } = payload;
            const ids: any = data.map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');
            const byEntityIdByModule: any = {};
            data.forEach((item: any) => {
                if (!byEntityIdByModule[item.entity_id]) byEntityIdByModule[item.entity_id] = {};
                byEntityIdByModule[item.entity_id][item.module] = item;
            });

            return {
                ...state,
                _isFetching: false,
                _forceFetch: false,
                ids,
                entities,
                byEntityIdByModule
            }
        }

        case getActionType(ACTIONS.CREATE_MODULE).REQUEST:
        case getActionType(ACTIONS.PATCH_MODULE).REQUEST: {
            return {
                ...state,
                _forceFetch: true
            }
        }

        
        case getActionType(ACTIONS.PATCH_MODULE).SUCCESS:
        case getActionType(ACTIONS.CREATE_MODULE).SUCCESS: {
            const { data } = payload;
            const ids = [...state.ids, data.id];
            const entities = {
                ...state.entities,
                [data.id]: data
            };
            const byEntityIdByModule = {
                ...state.byEntityIdByModule,
                [data.entity_id]: {
                    [data.module]: data
                }
            }

            return {
                ...state,
                _isFetching: false,
                _forceFetch: false,
                ids,
                entities,
                byEntityIdByModule
            }
        }

        default:
            return state;
    }
}

export default settingsModulesReducer;